export default __webpack_public_path__ + "static/cues-starters-dark-bb655358848d0dd1501ed8db81808b73.png";